"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoReviewRejectionReason = exports.AutoReviewOutcome = exports.BomItemResolutionCatalogue = exports.BomItemResolutionSource = exports.BomItemResolutionOutcome = exports.BomItemIdentifierClass = void 0;
var BomItemIdentifierClass;
(function (BomItemIdentifierClass) {
    BomItemIdentifierClass["Mpn"] = "mpn";
    BomItemIdentifierClass["SupplierPnOnly"] = "supplier_pn_only";
    BomItemIdentifierClass["None"] = "none";
    BomItemIdentifierClass["NotExtracted"] = "not_extracted";
})(BomItemIdentifierClass || (exports.BomItemIdentifierClass = BomItemIdentifierClass = {}));
var BomItemResolutionOutcome;
(function (BomItemResolutionOutcome) {
    BomItemResolutionOutcome["Package"] = "package";
    BomItemResolutionOutcome["SigmaModel"] = "sigma_model";
    BomItemResolutionOutcome["Unresolved"] = "unresolved";
    BomItemResolutionOutcome["NonElectrical"] = "non_electrical";
})(BomItemResolutionOutcome || (exports.BomItemResolutionOutcome = BomItemResolutionOutcome = {}));
var BomItemResolutionSource;
(function (BomItemResolutionSource) {
    BomItemResolutionSource["Fresh"] = "fresh";
    BomItemResolutionSource["ReusedOwned"] = "reused_owned";
    BomItemResolutionSource["ReusedCopy"] = "reused_copy";
})(BomItemResolutionSource || (exports.BomItemResolutionSource = BomItemResolutionSource = {}));
var BomItemResolutionCatalogue;
(function (BomItemResolutionCatalogue) {
    BomItemResolutionCatalogue["Digikey"] = "digikey";
    BomItemResolutionCatalogue["Octopart"] = "octopart";
    BomItemResolutionCatalogue["UltraLibrarian"] = "ultralibrarian";
    BomItemResolutionCatalogue["ParentDeployment"] = "parent_deployment";
    BomItemResolutionCatalogue["PreviousBuild"] = "previous_build";
    BomItemResolutionCatalogue["None"] = "none";
})(BomItemResolutionCatalogue || (exports.BomItemResolutionCatalogue = BomItemResolutionCatalogue = {}));
var AutoReviewOutcome;
(function (AutoReviewOutcome) {
    AutoReviewOutcome["Approved"] = "approved";
    AutoReviewOutcome["Rejected"] = "rejected";
})(AutoReviewOutcome || (exports.AutoReviewOutcome = AutoReviewOutcome = {}));
var AutoReviewRejectionReason;
(function (AutoReviewRejectionReason) {
    AutoReviewRejectionReason["PackageDraft"] = "package_draft";
    AutoReviewRejectionReason["NoValidator"] = "no_validator";
    AutoReviewRejectionReason["ParameterMissing"] = "parameter_missing";
    AutoReviewRejectionReason["ParameterOutOfRange"] = "parameter_out_of_range";
    AutoReviewRejectionReason["SignalsNotMapped"] = "signals_not_mapped";
    AutoReviewRejectionReason["Other"] = "other";
})(AutoReviewRejectionReason || (exports.AutoReviewRejectionReason = AutoReviewRejectionReason = {}));
//# sourceMappingURL=bom-resolution-enums.js.map